import type { FaireProductEntity } from "../../entity_types/product";

export const p_crnff75rkp: FaireProductEntity = {
  token: "p_crnff75rkp",
  type: "product",
  name: "Lacuna Ring in Red Jasper",
  brandToken: "b_93f50fc4",
  brandName: "Tiro Tiro Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/daf2b15badb4cab4705c961a0265314e4bfdf79be109daf8dd25a583168095af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a51ce331bc0fbfc922c42a74d06fce36b152b170fe24d9f557852bb567b87681.jpeg",
    "https://cdn.faire.com/fastly/16fb4ac600d61a3f2db30325a313a78af565a99035a66bd66ab1e007ec823a15.jpeg",
    "https://cdn.faire.com/fastly/706747a9df41d8aa3f6da23fbfb4c2ccf630d5fb62ecf7ebbc69b37d195bf39c.jpeg",
    "https://cdn.faire.com/fastly/756d8a310a2e3966a3d6ec5ce164e631edd1f8940748629311998379cf5ee9fa.jpeg",
    "https://cdn.faire.com/fastly/cac9ea99213b34ffbdaefdd56c7919c3e86465a75c5a03a51dbd331f160041ee.jpeg",
  ],
  priceDollars: 73.5,
  description:
    "Availability: Made to order, ships in 3-4 weeks. Need it sooner? Email us priori to placing your order and we'll do our best to accommodate.\n\nA clean, modern stone signet ring, set with a custom cut disc of red jasper.\n\n• Heavy bezel setting was hand carved in wax and then cast in brass or sterling silver, stone measures 5/8\" in diameter\n• Currently available in sizes 4-12. (Please contact us for custom sizing)",
  tags: [],
  msrpDollars: 147,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:05.914Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
